import { WithInternalMessages } from "features/CenterContent/RoleContent/InternalMessage/utils/withInternalMessages";
import { UpcomingEventsList } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/UpcomingEventsList";
import { InfrastructureResponse } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/types/responseSchema";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import {
  Flex,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "shared/components/Spor";
import { ParseResultDisplayer } from "shared/components/dataDisplay/ParseResultDisplayer";
import { isPlannedInfraStructureEvent } from "shared/utils/infrastructureEvent";
import { useParseResultContext } from "shared/utils/useParseResult";
import { useEventMode, useStretchBuilder } from "stores/useStretchBuilder";

type UpcomingEventsProps = {
  data: WithInternalMessages<InfrastructureResponse>[];
};

export const UpcomingEvents: FC<UpcomingEventsProps> = ({ data }) => {
  const { t } = useTranslation();
  const setEventMode = useEventMode((state) => state.setEventMode);
  const setStretchBuilderModalState = useStretchBuilder(
    (state) => state.setStretchBuilderModalState,
  );

  const onEditClick = (event: WithInternalMessages<InfrastructureResponse>) => {
    setEventMode(true);
    setStretchBuilderModalState({
      type: "infrastructure",
      eventInfo: event,
      stretchBuilderMode: false,
    });
  };

  const plannedEvents = data.filter((event) =>
    isPlannedInfraStructureEvent(event.type),
  );
  const unplannedEvents = data.filter(
    (event) => !isPlannedInfraStructureEvent(event.type),
  );

  const { errors } = useParseResultContext();

  return (
    <Flex flexDirection="column">
      <ParseResultDisplayer errors={errors("infrastructure")} />
      <Tabs
        fitted
        gap="18px"
        size="sm"
        marginTop="18px"
        defaultValue="upcomming"
        variant="accent"
      >
        <TabsList>
          <TabsTrigger value="upcomming">{t("Vis alle")}</TabsTrigger>
          <TabsTrigger value="planned">{t("Planlagt")}</TabsTrigger>
          <TabsTrigger value="unplanned">{t("Oppstått")}</TabsTrigger>
        </TabsList>
        <TabsContent value="upcomming">
          <UpcomingEventsList data={data} onEditClick={onEditClick} />
        </TabsContent>
        <TabsContent value="planned">
          <UpcomingEventsList data={plannedEvents} onEditClick={onEditClick} />
        </TabsContent>
        <TabsContent value="unplanned">
          <UpcomingEventsList
            data={unplannedEvents}
            onEditClick={onEditClick}
          />
        </TabsContent>
      </Tabs>
    </Flex>
  );
};
